import { Box, CircularProgress, DialogActions, DialogContent, DialogContentText, DialogTitle, IconButton, Typography } from "@mui/material";
import { BaseConfirmationModalPropsType } from "../../../types/app.type";
import { BaseConfirmationModalWrapper } from "./styled";
import CloseIcon from '@mui/icons-material/Close';
import { Caution } from "../../../assets";
import { BaseButton } from "../../button/styled";

export const BaseConfirmationModal: React.FC<BaseConfirmationModalPropsType> = ({ open, className, handleClose, title, body, error, isLoading, handleConfirm, handleCancel }) => {
    return (
        <BaseConfirmationModalWrapper
            open={open}
            className={className}
            onClose={handleClose}
        >
            <Box
                component={"div"}
                className="modal-heading"
            >
                <IconButton
                    onClick={handleCancel}
                >
                    <CloseIcon />
                </IconButton>
            </Box>
            <Box
                component={"div"}
                className="icon-box"
            >
                <Caution />
            </Box>
            <DialogTitle>
                {title || "Are You Sure?"}
            </DialogTitle>
            <DialogContent
                className="modal-content"
            >
                <DialogContentText
                    variant="body1"
                    fontFamily={"Inter"}
                    fontWeight={500}
                    fontSize={24}
                    lineHeight={"normal"}
                    color={"#666666"}
                    whiteSpace={"normal"}
                    textAlign={"center"}
                >
                    {body}
                </DialogContentText>
                {error && <Typography
                    fontFamily={"Inter"}
                    fontWeight={"600"}
                    fontSize={16}
                    lineHeight={"normal"}
                    color={"#FF0000"}
                    whiteSpace={"normal"}
                    textAlign={"center"}
                    marginBlockStart={"var(--basic-margin)"}
                >
                    {error}
                </Typography>}
            </DialogContent>
            <DialogActions
                disableSpacing
            >
                <BaseButton
                    bgcolor="#7B61FF"
                    variant="contained"
                    onClick={handleConfirm}
                >
                    {isLoading ? (
                        <CircularProgress color="inherit" className="loader" />
                    ) : (
                        <Typography
                            variant={"button"}
                            fontFamily={"inherit"}
                            fontWeight={"inherit"}
                            fontSize={"inherit"}
                            lineHeight={"inherit"}
                            color={"inherit"}
                            textTransform={"inherit"}
                        >
                            Confirm
                        </Typography>
                    )}
                </BaseButton>
                <BaseButton
                    bgcolor="#F4512E"
                    variant="contained"
                    onClick={handleCancel}
                >
                    <Typography
                        variant={"button"}
                        fontFamily={"inherit"}
                        fontWeight={"inherit"}
                        fontSize={"inherit"}
                        lineHeight={"inherit"}
                        color={"inherit"}
                        textTransform={"inherit"}
                    >
                        Cancel
                    </Typography>
                </BaseButton>
            </DialogActions>
        </BaseConfirmationModalWrapper>
    )
}